export default "__VITE_ASSET__D$$3iuhB__"